<div class="flex-columm flex-fill">
  <div class="row pb-2">
    <div class="col-md-12">
      <div class="float-end">
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel"
          [disabled]="!editMode || loading"
          (click)="cancelChanges();">Cancel
        </button>
        <button type="button" kendoButton [disabled]="loading" themeColor="primary" [svgIcon]="icons.plusCircle"
          (click)="addNewItem();">Create
        </button>
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save"
          [disabled]="!editMode || loading"
          (click)="saveChanges();">Save
        </button>
      </div>
    </div>
  </div>
  @if (ValidationErrors.size > 0 && editMode) {
    <div class="row mb-3">
      <div class="col-12">
        <div class="alert alert-danger mb-0" role="alert">
          <ul>
            @for (itemMessages of ValidationErrors | keyvalue; track itemMessages.key) {
              <li>
                {{itemMessages.key}}
                <ul>
                  @for (message of itemMessages.value; track message) {
                    <li>
                      {{message}}
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
  <ag-grid-angular #agGridFF
    class="ag-theme-balham"
    style="height:100%;min-height:500px;"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"
    (cellValueChanged)="onCellValueChanged($event)">
  </ag-grid-angular>
</div>
@if (showItemDetails) {
  <kendo-window title="{{Title}}" [width]="1000" (close)="showItemDetails=false" [minHeight]="400" [height]="600" [minWidth]="525">
    <app-items-details-rates [refreshRates]="refreshRateSubject.asObservable()" [itemId]="ItemId"></app-items-details-rates>
  </kendo-window>
}